var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNyc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 168,
    viewBox: "0 0 430 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.745 10.6053C376.263 11.1097 375.968 11.7451 375.968 12.3028C375.997 17.3952 375.987 22.4875 375.987 27.5799C375.987 30.6499 376.51 33.8411 375.851 36.7656C375.051 40.3302 371.998 42.8279 369.845 45.7088C368.032 48.1337 366.937 50.4665 367.213 53.5316C367.431 55.9372 367.189 58.3815 367.276 60.8016C367.359 63.0228 367.325 65.1228 365.323 66.6311C364.368 67.3489 364.305 68.4062 364.329 69.5314C364.387 72.1988 364.164 74.8808 364.392 77.5288C364.722 81.3602 364.092 84.8327 361.416 87.6942C360.505 88.669 360.466 89.7117 360.466 90.8708C360.476 98.5482 360.48 106.23 360.456 113.908C360.456 114.713 360.791 115.571 359.986 116.454H349.123C348.672 115.474 348.842 114.558 348.842 113.665C348.832 96.1232 348.808 78.5861 348.852 61.0441C348.866 55.6122 346.544 51.4559 341.998 48.7593C340.054 47.6051 339.429 46.3974 339.598 44.312C340.005 39.2827 339.448 34.3503 336.675 30.0291C332.894 24.1462 327.397 20.6979 320.471 19.5825C320.156 19.534 319.821 19.5437 319.501 19.5825C319.172 19.6261 318.852 19.7377 318.517 19.8201C318.125 20.6785 318.294 21.5952 318.294 22.4827C318.285 41.1547 318.289 59.8268 318.285 78.4988C318.285 80.5972 317.234 81.648 315.134 81.6512C313.035 81.6512 310.931 81.6561 308.832 81.6415C308.672 81.6415 308.517 81.4766 308.105 81.2487C308.105 77.7762 307.945 74.1242 308.154 70.4965C308.318 67.6496 307.761 65.215 305.677 63.2217C303.999 61.6164 303.428 59.6764 303.723 57.397C303.835 56.524 303.631 55.6025 303.762 54.7344C304.431 50.2482 303.074 46.4702 299.855 43.342C298.997 42.5078 298.861 41.5476 298.876 40.4224C298.924 36.46 298.915 32.5025 298.876 28.5402C298.871 27.7351 299.21 26.8767 298.299 25.8728C293.403 25.8728 288.149 25.8631 282.899 25.8825C282.007 25.8825 281.503 26.4353 281.45 27.3277C281.411 27.9728 281.445 28.6226 281.445 29.2677C281.445 62.8919 281.445 96.5209 281.44 130.145C281.44 131.038 281.61 131.954 281.159 132.934H273.011C272.56 131.954 272.729 131.038 272.729 130.145C272.72 113.898 272.628 97.651 272.778 81.4039C272.826 76.423 272.056 71.709 270.316 67.0919C270.03 66.3304 270 65.4769 269.807 64.6766C269.506 63.4205 268.939 62.6348 267.388 62.6979C264.324 62.8191 261.246 62.824 258.183 62.6979C256.782 62.6397 256.307 63.2702 255.992 64.4341C254.324 70.5547 252.429 76.5637 252.763 83.111C253.141 90.6089 252.86 98.1408 252.836 105.658C252.836 106.463 253.171 107.322 252.366 108.204H246.064V57.5134C243.364 57.7462 242.914 56.3057 243.137 54.2494C243.238 53.2891 243.083 52.3046 243.171 51.3443C243.326 49.6372 243.054 48.3034 241.033 48.3471C240.335 46.0434 241.101 43.7931 240.461 41.3972H232.977V33.9236C230.471 33.3028 228.212 33.5889 225.706 33.7684V44.3459C224.741 45.151 223.743 44.3556 222.797 45.5245V57.0866C220.475 57.0381 220.34 58.3718 220.345 60.0741C220.398 72.4413 220.374 84.8085 220.364 97.1757C220.364 98.068 220.534 98.9847 220.083 99.9643H208.735V72.4413C204.537 72.4413 200.577 72.4461 196.617 72.4413C193.902 72.4413 193.713 72.2521 193.709 69.5314C193.704 64.924 193.709 60.3117 193.709 55.4667H185.953V49.2831H166.564V55.4667H158.323V140.218H151.338C150.887 139.239 151.057 138.322 151.057 137.43C151.047 117.948 151.047 98.4706 151.057 78.9886C151.057 77.8295 151.232 76.7286 149.85 76.0593C145.458 73.9351 141.125 71.6993 136.728 69.5799C136.467 69.4538 135.992 68.9882 135.177 69.7933V114.514H126.331V111.968C126.331 104.048 126.331 96.1232 126.331 88.2034C126.331 87.2043 126.447 86.1907 125.846 85.2935",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.987 38.2499C379.002 41.4605 381.193 45.2968 383.995 48.6723C384.455 49.2252 384.203 49.8168 384.213 50.3794C384.247 53.6919 384.285 57.0092 384.213 60.3217C384.159 62.8582 383.965 65.3365 386.636 66.8981C387.654 67.4947 387.659 68.6538 387.64 69.7789C387.586 72.8489 387.756 75.9286 387.582 78.9889C387.397 82.2189 387.766 85.1337 390.262 87.5004C391.106 88.3006 391.023 89.5034 391.023 90.6286C391.004 103.641 391.009 116.658 391.018 129.67C391.018 130.562 390.849 131.479 391.353 132.58C393.912 132.58 396.583 132.609 399.249 132.565C400.102 132.551 400.616 131.979 400.694 131.125C400.752 130.485 400.703 129.835 400.703 129.185C400.703 113.99 400.703 98.7909 400.708 83.5962C400.708 82.7039 400.538 81.7872 400.989 80.8076H424.455V166.044H446.268",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.229 84.566C121.585 87.3159 117.014 90.2016 112.249 92.7332C110.689 93.5626 110.32 94.3919 110.325 95.9633C110.369 112.778 110.354 129.587 110.349 146.402C110.349 149.55 110.349 149.579 107.199 149.54C105.904 149.525 104.591 149.782 103.078 149.22V138.497C101.547 138.424 100.247 138.366 98.7157 138.293V135.727C98.7157 129.02 98.7012 122.308 98.7254 115.6C98.7254 114.301 98.7981 113.151 97.024 112.889C95.9818 112.734 95.7298 111.822 95.7782 110.751C95.8703 108.573 95.8025 106.386 95.8073 104.203C95.8073 102.981 96.0448 101.769 94.3677 101.24C93.4467 100.949 93.8829 99.8432 93.8829 99.1108C93.8587 89.0861 93.8732 79.0663 93.8587 69.0416C93.8587 68.1492 94.0284 67.2326 93.6357 66.379C92.9765 66.2141 92.3318 66.0541 91.4447 65.831V56.1942C91.4447 55.6268 91.6871 54.8314 91.4059 54.5307C88.866 51.8245 90.4219 48.5217 89.9857 45.5245C89.9372 45.1947 89.8306 44.8795 89.7482 44.5545C89.1035 44.3945 88.4539 44.2296 87.8092 44.0696C87.3391 42.7989 87.6008 41.4846 87.5814 40.1896C87.5378 37.3719 87.2324 37.0857 84.4161 37.5271C84.0865 37.5804 83.7714 37.6871 83.4176 37.7744C82.8165 39.7532 83.6115 41.8483 82.865 43.9871C80.8824 43.9435 80.6401 45.2772 80.7564 46.9843C80.8582 48.512 80.7758 50.0543 80.7758 51.5917C80.7758 51.9943 80.9455 52.6296 80.7516 52.7702C78.2213 54.6374 79.5834 57.3 79.3652 59.5989C79.1665 61.6843 79.3216 63.8037 79.3216 65.8407C78.4345 66.0638 77.785 66.2238 76.8979 66.4469V68.8088C76.8979 78.8335 76.8979 88.8533 76.8979 98.878C76.8979 100.1 77.1549 101.366 75.4486 101.822C74.673 102.03 74.9687 102.894 74.9639 103.485C74.9445 105.993 74.9493 108.495 74.959 111.003C74.959 111.91 74.9736 112.943 73.7472 112.914C71.8034 112.87 72.0555 114.179 72.0506 115.368C72.0458 122.157 72.0603 128.947 72.0312 135.737C72.0312 136.542 72.3657 137.401 71.561 138.283H66.229V101.06H58.4733V72.1746C57.2663 72.0242 56.2872 71.903 55.0802 71.7478V65.9474C52.831 65.4979 51.7 64.1076 51.6871 61.7765C51.6774 60.0079 50.7887 59.1187 49.021 59.109C46.9997 59.0993 44.9784 59.1915 42.9619 59.0799C41.4398 58.9975 40.9939 59.6425 40.9987 61.049C41.0036 62.5039 41.2557 63.9832 40.8 65.3848C40.0632 66.0298 39.055 65.1956 38.1146 66.442V71.7478C36.9076 71.8982 35.9285 72.0194 34.7215 72.1746V115.489H26.9658V77.9023H12.4238V91.1182C12.0991 91.1182 12.0167 91.1085 11.9391 91.1182C7.35354 91.8603 7.09178 91.6517 7.09178 87.2383C7.09178 78.4261 7.12087 69.6187 7.07724 60.8065C7.0627 57.3097 4.60996 55.103 2.44321 52.843C1.68218 52.0476 0.383097 52.6344 -0.66877 52.5811C-2.20052 52.5035 -3.73712 52.6005 -5.27372 52.552C-6.82971 52.5035 -7.47439 53.1922 -7.47924 54.7441C-7.47924 56.3591 -7.23202 57.9984 -7.70221 59.7444C-8.9916 59.8026 -10.2858 59.8656 -11.8224 59.9384V106.478C-12.2345 106.706 -12.3896 106.871 -12.5495 106.871C-19.0789 106.861 -18.0949 107.521 -18.1191 101.788C-18.1482 93.7032 -18.1142 85.6233 -18.1433 77.5386C-18.1433 76.7286 -17.9979 75.9527 -18.5602 75.0845C-20.9742 71.3598 -22.8307 67.2714 -25.8796 63.9589",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.255 79.2312V145.675",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5279 81.4136C17.4455 82.8685 17.3001 84.3235 17.2953 85.7785C17.2759 101.138 17.2807 116.493 17.2953 131.852C17.2953 132.822 17.4455 133.792 17.5279 134.762",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.65 78.0187C140.568 79.4736 140.422 80.9286 140.417 82.3836C140.398 97.2581 140.403 112.128 140.422 127.002C140.422 127.808 140.136 128.661 140.65 129.427",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3752 103.723C22.826 104.053 22.6079 104.533 22.6079 104.936C22.6225 118.03 22.6225 131.125 22.6079 144.22C22.6079 144.622 22.826 145.102 22.3752 145.432",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.598 0.90564V33.2786",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.281 30.0049C287.281 38.9772 287.291 47.9494 287.271 56.9217C287.271 57.9741 287.121 59.0217 287.039 60.0741",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.34 30.0049C293.258 31.6199 293.113 33.2398 293.108 34.8548C293.083 42.212 293.088 49.5644 293.108 56.9217C293.108 57.9741 293.258 59.0217 293.34 60.0741",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.34 65.4089C292.812 67.4119 293.127 69.4537 293.117 71.4713C293.074 79.1486 293.098 86.8308 293.098 94.5082",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.039 99.8431C287.567 101.846 287.252 103.888 287.262 105.905C287.305 113.583 287.281 121.265 287.281 128.942",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.281 65.6516V94.5084",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.34 99.8431C292.807 102.171 293.136 104.533 293.117 106.875C293.059 113.34 293.083 119.81 293.117 126.275C293.117 126.998 292.802 127.783 293.34 128.457",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3901 14.0002C85.9379 18.1954 85.5307 22.4051 85.6179 26.6099C85.6907 30.1261 85.6325 33.6423 85.6325 37.1584",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.011 137.187C398.464 142.677 398.881 148.182 398.793 153.677C398.769 155.287 398.493 156.931 399.011 158.527",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.039 134.277C287.601 140.01 287.155 145.757 287.257 151.494C287.281 152.862 287.577 154.269 287.039 155.617",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.439 110.028C380.195 110.576 374.935 110.13 369.686 110.266C368.314 110.3 366.937 110.27 365.565 110.27",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.439 88.2035C380.195 88.7515 374.935 88.3053 369.686 88.4411C368.314 88.4751 366.937 88.446 365.565 88.446",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.439 95.4783C380.195 96.0263 374.935 95.5801 369.686 95.7159C368.314 95.7499 366.937 95.7208 365.565 95.7208",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.439 117.303C380.195 117.851 374.935 117.405 369.686 117.541C368.314 117.574 366.937 117.545 365.565 117.545",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.439 102.753C380.195 103.301 374.935 102.855 369.686 102.991C368.314 103.025 366.937 102.996 365.565 102.996",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.439 124.578C380.195 125.126 374.935 124.679 369.686 124.815C368.314 124.849 366.937 124.82 365.565 124.82",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.439 131.852C378.978 132.255 372.511 132.255 366.05 131.852",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3752 81.4136C22.9036 86.9036 22.4819 92.4082 22.6176 97.9032",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.501 81.4138C378.178 80.8512 372.836 81.3265 367.504 81.1713",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.504 73.8964C368.498 74.4153 369.574 74.4153 370.655 74.3814C374.935 74.2504 379.225 74.6626 383.501 74.1389",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.68 137.187C394.126 142.037 394.004 146.887 393.68 151.737",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.623 139.127C374.945 139.685 370.248 139.214 365.565 139.37",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.932 58.8618C230.631 59.7784 234.358 59.342 238.081 59.1043",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 92.5684C234.373 93.0824 230.645 92.6896 226.932 92.8109",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.714 146.645H365.565",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 50.8593C234.373 50.3452 230.645 50.738 226.932 50.6168",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 67.5916H226.932",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 126.275H226.932",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 134.762C234.373 134.273 230.65 134.627 226.932 134.52",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 101.298C234.373 100.784 230.645 101.177 226.932 101.056",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 117.788C234.373 118.302 230.645 117.909 226.932 118.03",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 75.8363H226.932",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 109.543C234.373 109.053 230.65 109.407 226.932 109.3",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.34 134.277C292.938 137.832 292.938 141.392 293.34 144.947",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2 113.908C120.131 114.213 117.058 114.369 113.99 113.908",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.237 105.663C217.615 108.733 217.615 111.808 217.237 114.878",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.39 105.663C212.012 108.733 212.012 111.808 212.39 114.878",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2 120.94C120.131 121.086 117.048 120.644 113.99 121.183",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.148 120.213C212.25 123.283 211.905 126.367 212.39 129.428",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2 99.6007C120.131 99.7462 117.048 99.3049 113.99 99.8432",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.199 128.215H114.232",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.199 106.875H114.232",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.199 142.28H114.232",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.199 149.554H114.232",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.577 97.4182C314.668 97.0399 311.76 97.0399 308.852 97.4182",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.577 127.972C314.668 127.58 311.76 127.623 308.852 127.972",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 143.007C235.172 143.317 232.264 143.473 229.355 143.007",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.577 120.213C314.668 120.577 311.76 120.577 308.852 120.213",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.577 135.49H308.852",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.577 104.936H308.852",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.577 112.695C314.668 112.594 311.75 112.943 308.852 112.453",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.932 84.0812C230.645 84.2412 234.373 83.7999 238.081 84.3237",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.622 59.5892C376.888 60.1227 374.125 59.6911 371.382 59.8317",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.148 149.312C212.288 152.057 211.857 154.821 212.39 157.557",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.148 134.762C212.288 137.507 211.857 140.272 212.39 143.007",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2 135.005C120.151 135.863 117.068 135.563 113.99 135.247",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.622 66.8639C376.888 67.3974 374.125 66.9657 371.382 67.1064",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.38 52.557H371.382",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.479 134.762V142.765",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.479 120.213V128.215",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.081 151.252C235.507 151.708 232.909 151.407 230.325 151.494",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.577 89.6586H310.306",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.807 156.587C117.868 156.98 115.929 156.98 113.99 156.587",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.592 118.758C253.093 118.84 252.346 118.462 252.375 119.485C252.409 120.615 252.38 121.75 252.38 122.88",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.184 150.767C312.405 151.32 310.631 150.912 308.852 150.767",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.941 143.25H308.852",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.767 114.393C406.685 116.09 406.607 117.788 406.525 119.485",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.282 128.943C406.665 130.558 406.665 132.177 406.282 133.792",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.584 156.587C413.088 158.1 412.7 159.662 412.826 161.194",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.584 114.878C413.088 116.391 412.7 117.953 412.826 119.485",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.826 101.541C412.7 103.073 413.088 104.635 412.584 106.148",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.525 101.541C406.399 103.073 406.786 104.635 406.282 106.148",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.128 101.541C419.254 103.073 418.866 104.635 419.37 106.148",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.282 87.2335C406.786 88.7467 406.399 90.3083 406.525 91.8409",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01685 93.0535C2.03623 93.5142 1.89566 94.038 2.60337 94.3144C2.8118 93.8925 3.02024 93.4706 3.22867 93.0535",
    stroke: "#0D6EFD",
    strokeOpacity: 0.5,
    strokeWidth: 1.81214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 627,
    height: 167.321,
    fill: "white",
    transform: "translate(-180 0.178223)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNyc);
export default __webpack_public_path__ + "static/media/nyc.889330d89cace6a01a1e96ac01da2ff5.svg";
export { ForwardRef as ReactComponent };